import React, { useEffect, useState } from "react";
import { getTimeDiff, getTimeString } from "../misc/helperfuncs";
import MainStore from "../stores/MainStore";
import BackgroundDiv from "../misc/elements/BackgroundDiv";
import Checkmark from "../misc/elements/Checkmark";
import LiveRating from "../misc/elements/LiveRating";
import TimePassed from "./TimePassed";
import activeStore from "../stores/activeStore";
import DetailedMoods from "../detailedView/DetailedMoods";
import OpacityImg from "../misc/elements/OpacityImg";
import useHandlePlayerArrays from "../hooks/useHandlePlayerArrays";
import ActiveNumberHolder, { makeActiveNumber } from "./ActiveNumberHolder";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import Header from "./Header";
import NumberBar from "./NumberBar";
import activeNumbers from "./activeNumbers";
import ActiveButtons from "./ActiveButtons";

const ActiveGoalDisplay = ({ player, setShowActiveGoal, handleActive }) => {
  const [totalTime, setTotalTime] = useState({ seconds: 0, minutes: 0 });
  const [displayedNumbers, setDisplayedNumbers] = useState([]);
  const { getBoxType } = useHandleBoxTypes();
  const [openObject, setOpenObject] = useState(null);
  const [savedObject, setSavedObject] = useState(null);
  const { findObjectById } = useHandlePlayerArrays();
  const { goal, setActive } = activeStore();
  const boxType = getBoxType("goal");
  function onGoalCompleted() {}

  useEffect(() => {
    if (openObject && savedObject) {
      const n = activeNumbers(savedObject, openObject);
      setDisplayedNumbers(n);
    }
  }, [openObject, savedObject]);

  useEffect(() => {
    function onObjectFound(objects) {
      console.log("obejcts: ", objects);
      if (objects.open) {
        setTotalTime({ seconds: 0, minutes: objects.open.minutes.active });
        setOpenObject(objects.open);
        setSavedObject(objects.saved);
      } else {
        handleActive.resetActiveObject();
      }
    }
    if (goal) findObjectById(goal.id, "goal", onObjectFound);
  }, []);

  return (
    <div
      className="divRow"
      style={{
        backgroundColor: "#bbe3f0",
        padding: "10px",
        borderRadius: "1rem/1rem",
        border: "4px solid #b0d5e1",
        height: "100%",
      }}
    >
      <img src={player.active?.goal?.image} style={{ maxHeight: "100%" }} />
      <div
        className="divColumn"
        style={{
          width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        <Header shortDescription={player.active.goal?.shortDescription} />
        <div className="divRow" style={{ width: "100%", height: "100%" }}>
          <TimePassed
            timePassed={handleActive.timePassed}
            totalPassed={totalTime}
          />
          <div
            className="divColumn"
            style={{
              flex: 1,
              width: "100%",
              height: "100%",
              justifyContent: "space-around",
            }}
          >
            <NumberBar
              openObject={openObject}
              savedObject={savedObject}
              numbers={displayedNumbers}
            />
            <div
              className="divRow"
              style={{ justifyContent: "space-around", width: "100%" }}
            >
              <LiveRating
                rated={goal.ratings.first}
                icon={boxType.ratings.active.first.icon}
                description={boxType.ratings.active.first.hint}
                field={"first"}
                onTick={handleActive.onRatingTick}
                tickTiming={1.5}
              />
              <LiveRating
                rated={goal.ratings.second}
                icon={boxType.ratings.active.second.icon}
                description={boxType.ratings.active.second.hint}
                field={"second"}
                onTick={handleActive.onRatingTick}
                tickTiming={2}
              />
            </div>
          </div>
        </div>
      </div>
      <ActiveButtons
        setShowActiveGoal={setShowActiveGoal}
        box={goal}
        stopActive={handleActive.stopActive}
        onCompleted={handleActive.onGoalCompleted}
      />
    </div>
  );
};

export default ActiveGoalDisplay;
